import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isUndefined } from 'lodash-es';
import { isDefined } from './validators';
var w = window;
export function getScriptCache() {
  if (w._scriptCache) {
    return w._scriptCache;
  }
  var sc = new ScriptCache();
  w._scriptCache = sc;
  return w._scriptCache;
}
export var ScriptCache = function () {
  function ScriptCache(scripts) {
    var _this = this;
    _classCallCheck(this, ScriptCache);
    _defineProperty(this, "scripts", new Map());
    _defineProperty(this, "_loadScript", function () {
      var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(src) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                var body = document.getElementsByTagName('body')[0];
                var tag = document.createElement('script');
                tag.type = 'text/javascript';
                tag.async = false;
                tag.src = src;
                tag.onload = function () {
                  return resolve(tag);
                };
                tag.onerror = function () {
                  return reject();
                };
                tag.addEventListener('load', tag.onload);
                tag.addEventListener('error', tag.onerror);
                body.appendChild(tag);
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "add", function (key, src) {
      var script = _this.scripts.get(key);
      if (isDefined(script)) {
        return script;
      }
      if (typeof document === 'undefined') return undefined;
      var onLoad = _this._loadScript(src).then(function (tag) {
        var stored = _this.scripts.get(key);
        if (isUndefined(stored)) return;
        stored.tag = tag;
        stored.resolved = true;
        stored.loaded = true;
        return;
      })["catch"](function (err) {
        var stored = _this.scripts.get(key);
        if (isUndefined(stored)) return;
        stored.error = true;
        stored.loaded = true;
        throw err;
      });
      var newScript = {
        onLoad: onLoad,
        tag: null,
        loaded: false,
        error: false,
        resolved: false
      };
      _this.scripts.set(key, newScript);
      return newScript;
    });
    if (scripts) {
      Object.keys(scripts).forEach(function (key) {
        var url = scripts[key];
        if (!_this.scripts.has(key)) {
          _this.add(key, url);
        }
      });
    }
  }
  _createClass(ScriptCache, [{
    key: "get",
    value: function get(key) {
      return this.scripts.get(key);
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.scripts.has(key);
    }
  }]);
  return ScriptCache;
}();